import { render } from "./DesignSwiss.vue?vue&type=template&id=c5eb25ae&scoped=true"
import script from "./DesignSwiss.vue?vue&type=script&lang=js"
export * from "./DesignSwiss.vue?vue&type=script&lang=js"

import "./DesignSwiss.vue?vue&type=style&index=0&id=c5eb25ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5eb25ae"]])

export default __exports__